<template>
  <div>
    <Nav :showMobileSearch="false" ref="Nav" />
    <div class="record-detail">
      <div class="bg-img">
        <img
          v-if="recordInfo.cover && recordInfo.cover.length > 0"
          :src="
            'https://img.library.sh.cn/hisdata/cp/img/' +
            recordInfo.cover[picIndex]
          "
        />
        <img v-else :src="baseRecordPic" class="cur" />
        <div class="bg"></div>
      </div>
      <div class="main-box">
        <div class="record-info">
          <div class="pic-show">
            <div class="cur-pic">
              <img
                v-if="recordInfo.cover && recordInfo.cover.length > 0"
                :src="
                  'https://img.library.sh.cn/hisdata/cp/img/' +
                  recordInfo.cover[picIndex]
                "
                class="cur"
              />
              <img v-else :src="baseRecordPic" class="cur" />
              <div
                class="hover-txt"
                v-if="recordInfo.cover && recordInfo.cover.length > 0"
                @click="checkPic"
              >
                查看大图
              </div>
            </div>
            <div class="pic-tab">
              <div
                v-if="recordInfo.cover && recordInfo.cover.length > 0"
                class="inner-scroll"
                :style="
                  !isMobile
                    ? 'width:' +
                      recordInfo.cover.length * 47 +
                      'px;left:' +
                      -picTabScroll * 47 +
                      'px'
                    : ''
                "
              >
                <a
                  v-for="(item, index) in recordInfo.cover"
                  :key="index"
                  href="javascript:"
                  :class="index === picIndex ? 'cur' : ''"
                  @click="picIndex = index"
                >
                  <img
                    v-if="item"
                    :src="'https://img.library.sh.cn/hisdata/cp/img/' + item"
                    alt=""
                  />
                  <img v-else :src="baseRecordPic" alt="" />
                </a>
              </div>
            </div>
            <span
              v-if="picTabScroll !== 0"
              class="prev"
              @click="picTabScrollHandle(false)"
            ></span>
            <span
              v-if="
                recordInfo.cover &&
                recordInfo.cover.length > 3 &&
                picTabScroll <= recordInfo.cover.length - 3
              "
              class="next"
              @click="picTabScrollHandle(true)"
            ></span>
          </div>
          <div class="info">
            <div class="name" v-if="recordInfo.mytitle">
              {{ recordInfo.mytitle }}
            </div>
            <div class="des" v-if="recordInfo.contribution">
              <SingerTemplate :recordInfo="recordInfo"></SingerTemplate>
            </div>
            <div
              class="des"
              v-if="
                recordInfo.classification && recordInfo.classification.prefLabel
              "
            >
              <i>{{ recordInfo.classification.prefLabel["@value"] }}</i>
            </div>
            <div
              class="des"
              v-if="
                recordInfo.collection && Array.isArray(recordInfo.collection)
              "
            >
              <i>所属专题：</i>
              <span>
                <router-link
                  v-for="(s, index) in recordInfo.collection"
                  :key="'collection' + index"
                  :to="'/special/' + encodeURIComponent(s.uri)"
                >
                  {{ s.title
                  }}<template v-if="index < recordInfo.collection.length - 1"
                    >、</template
                  >
                </router-link>
              </span>
            </div>

            <div class="btns">
              <ShareDialog ref="share"
                ><a href="javascript:" class="share" @click="handleShare"
                  ><i></i>分享</a
                >
              </ShareDialog>
              <a
                href="javascript:"
                :class="recordInfo.isFavorite ? 'fav cur' : 'fav'"
                @click="handleSingleFav"
                ><i></i>{{ recordInfo.isFavorite ? "已" : "" }}收藏</a
              >
            </div>
          </div>
        </div>
        <div class="mb-detail-info">
          <div class="des" v-if="recordInfo.contribution">
            <SingerTemplate :recordInfo="recordInfo"></SingerTemplate>
          </div>
          <div
            class="des"
            v-if="
              recordInfo.classification && recordInfo.classification.prefLabel
            "
          >
            <i>{{ recordInfo.classification.prefLabel["@value"] }}</i>
          </div>
        </div>

        <div class="record-song-list" v-if="audioList && audioList.length > 0">
          <a href="javascript:" class="all-play" @click="addAll()"
            ><i></i>全部播放({{ audioList.length }})</a
          >

          <div class="tit">
            <i></i>
            <div class="tap">
              <span class="cur">唱片曲目</span>
            </div>
          </div>

          <div class="rs-list">
            <div
              v-for="(item, index) in audioList"
              :key="'audioList' + index"
              class="rs-cell"
            >
              <div class="cd">
                <span v-if="item['source']['serialNo']"
                  >CD {{ item["source"]["serialNo"] }}</span
                >
                {{ item["identifier"].split("_")[1] }}面-{{
                  item["identifier"].split("_")[2]
                }}
              </div>
              <div
                :class="playIndex == index ? 'name cur' : 'name'"
                v-if="item.title"
                :title="item.dctitle['@value']"
                @click="titleClick(item)"
              >
                {{ item.dctitle["@value"] | ellipsis }}
              </div>
              <div class="des" :title="item.creator">
                <span v-if="item.creator">{{ item.creator }}</span>
              </div>
              <div class="time" v-if="item.extent">
                <span v-if="item.extent">{{ item.extent }}</span>
              </div>
              <div class="act">
                <span
                  v-if="item.playable"
                  :class="playIndex == index ? 'play curPlay' : 'play'"
                  @click="playSong(item, index)"
                ></span>
                <span
                  :class="item.isFavorite ? 'fav cur' : 'fav'"
                  @click="handleFav(index)"
                ></span>
                <ShareIcon
                  :shareConfig="{
                    url: '/song-detail/' + encodeURIComponent(item['@id']),
                    title: item.dctitle['@value'],
                  }"
                ></ShareIcon>
              </div>
            </div>
          </div>
        </div>
        <div class="record-info-detail">
          <div class="tit"><i></i>唱片详情</div>
          <div class="des-info">
            <div class="left-des">
              <div class="bs-info" v-if="recordInfo.dcTitle">
                <span class="lb">唱片名称</span>
                <div class="mh">:</div>
                <span class="vl"
                  >{{ recordInfo.mytitle }}
                  <!-- <span class="lb" v-if="Array.isArray(recordInfo.variantTitle)"
                    >
                    、又名 {{ recordInfo.variantTitle[0].label }}
                  </span> -->
                </span>
              </div>
              <!-- <div class="bs-info" v-if="recordInfo.variantTitle">
                <span class="lb">其他题名</span>
                <div class="mh">:</div>
                  <span class="vl" v-if="Array.isArray(recordInfo.variantTitle)">
                     {{ recordInfo.variantTitle[0].label.replace('~','').replace(/[||]/g,'#').replace(/##/g,'')}}
                  </span>
                
              </div> -->
              <div class="bs-info" v-if="recordInfo.contribution">
                <span class="lb">乐人</span>
                <div class="mh">:</div>
                <span class="vl">
                  <SingerTemplate :recordInfo="recordInfo"></SingerTemplate>
                </span>
              </div>
              <div class="bs-info" v-if="recordInfo.instrument">
                <span class="lb">音乐类型</span>
                <div class="mh">:</div>
                <span class="vl"
                  ><em>{{ recordInfo.instrument }}</em></span
                >
              </div>
              <!-- <div class="bs-info" v-if="recordInfo.language">
                <span class="lb">语种</span>
                <div class="mh">:</div>
                <span class="vl">{{ recordInfo.language["@value"] }}</span>
              </div> -->
              <div
                class="bs-info"
                v-if="recordInfo.note && !Array.isArray(recordInfo.note)"
              >
                <span class="lb">形态细节</span>
                <div class="mh">:</div>
                <span class="vl">{{
                  recordInfo.note.label
                    .replace(/[||]/g, "#")
                    .replace(/##/g, "、")
                }}</span>
              </div>
              <div class="bs-info" v-if="recordInfo.aria">
                <span class="lb">唱法唱腔</span>
                <div class="mh">:</div>
                <span class="vl">{{ recordInfo.aria }}</span>
              </div>
              <div
                class="bs-info"
                v-if="
                  recordInfo.provisionActivity &&
                  recordInfo.provisionActivity.agentLabel
                "
              >
                <span class="lb">出版者</span>
                <div class="mh">:</div>

                <span
                  class="vl"
                  v-if="
                    recordInfo.provisionActivity.agent &&
                    recordInfo.provisionActivity.agentLabel &&
                    recordInfo.provisionActivity.agent['@id'] &&
                    recordInfo.provisionActivity.agent['@id'].search(
                      'http://data.library.sh.cn/entity/organization/'
                    ) >= 0
                  "
                >
                  <router-link
                    :to="
                      '/company-detail/' +
                      encodeURIComponent(
                        recordInfo.provisionActivity.agent['@id']
                      )
                    "
                  >
                    {{ recordInfo.provisionActivity.agentLabel }}
                  </router-link> </span
                ><!--未规范人或机构-单值--->
                <span v-else class="vl">{{
                  recordInfo.provisionActivity.agentLabel
                }}</span>
              </div>
              <div
                class="bs-info"
                v-if="
                  recordInfo.provisionActivity &&
                  recordInfo.provisionActivity.placeLabel
                "
              >
                <span class="lb">出版地点</span>
                <div class="mh">:</div>
                <span class="vl">{{
                  recordInfo.provisionActivity.placeLabel
                }}</span>
              </div>
              <div
                class="bs-info"
                v-if="
                  recordInfo.provisionActivity &&
                  recordInfo.provisionActivity.date
                "
              >
                <span class="lb">出版时间</span>
                <div class="mh">:</div>
                <span class="vl">{{ recordInfo.provisionActivity.date }}</span>
              </div>

              <div class="bs-info" v-if="recordInfo.extent">
                <span class="lb">数量</span>
                <div class="mh">:</div>
                <span class="vl">{{ recordInfo.extent }}</span>
              </div>
              <div class="bs-info" v-if="recordInfo.dimensions">
                <span class="lb">尺寸</span>
                <div class="mh">:</div>
                <span class="vl">{{ recordInfo.dimensions }}</span>
              </div>
              <div class="bs-info" v-if="recordInfo.volume">
                <span class="lb">卷标识</span>
                <div class="mh">:</div>
                <span class="vl">{{ recordInfo.volume }}</span>
              </div>

              <div
                class="bs-info"
                v-if="recordInfo.note && Array.isArray(recordInfo.note)"
              >
                <span class="lb">附注</span>
                <div class="mh">:</div>
                <span class="vl">
                  <span
                    v-for="(item, pIndex) in recordInfo.note"
                    :key="'note' + pIndex"
                  >
                    {{ item.label ? item.label + "&nbsp;&nbsp;" : "" }}
                  </span>
                </span>
              </div>
              <div class="bs-info" v-else-if="recordInfo.label">
                <span class="lb">附注</span>
                <div class="mh">:</div>
                <span class="vl">{{ recordInfo.label }}</span>
              </div>

              <!-- </div>
            <div class="left-des"> -->
              <div
                class="bs-info"
                v-if="recordInfo.subject && Array.isArray(recordInfo.subject)"
              >
                <span class="lb">主题</span>
                <div class="mh">:</div>
                <span class="vl" v-if="Array.isArray(recordInfo.subject)">
                  <span
                    href="javascript:;"
                    v-for="(s, index) in recordInfo.subject"
                    :key="'subject' + index"
                    >{{ s.label
                    }}<template v-if="index < recordInfo.subject.length - 1"
                      >、</template
                    ></span
                  >
                </span>
                <span v-else>{{ recordInfo.subject }}</span>
              </div>
              <div class="bs-info" v-if="recordInfo.language">
                <span class="lb">语种</span>
                <div class="mh">:</div>
                <span class="vl">{{ recordInfo.language["@value"] }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="collection-info" v-if="recordInfo.item && hasShelfMark">
          <div class="tit"><i></i>馆藏信息</div>
          <div class="info-x">
            <div
              class="bs-info"
              v-if="recordInfo.item && Array.isArray(recordInfo.item)"
            >
              <span class="lb">索书号</span>
              <div class="mh">:</div>
              <span class="vl"
                ><span v-for="(itemInfo, index) in recordInfo.item" :key="index"
                  >{{ itemInfo.shelfMark }}
                  <template v-if="itemInfo.identifiedBy"
                    >（{{ itemInfo.identifiedBy }}）</template
                  ><template v-if="index < recordInfo.item.length - 1"
                    ><br
                  /></template> </span
              ></span>
            </div>

            <div v-else class="bs-info">
              <span class="lb">索书号</span>
              <div class="mh">:</div>
              <span class="vl"
                >{{ recordInfo.item.shelfMark }}
                <template v-if="recordInfo.item.identifiedBy"
                  >（{{ recordInfo.item.identifiedBy }}）</template
                ></span
              >
            </div>
            <!-- <div class="bs-info">
                <span class="lb">馆藏机构</span>
                <div class="mh">:</div>
                <span class="vl">{{ recordInfo.item.heldBy.label }}</span>
              </div> -->

            <!-- <div class="bs-info" v-if="recordInfo.item && recordInfo.item.identifiedBy">
              <span class="lb">条码号</span>
              <div class="mh">:</div>
              <span class="vl"></span>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="space-footer"></div>
    <Player ref="player" @saveFav="saveFav" @curPlay="curPlay" />
    <div :class="imgView ? 'img-full-tk cur' : 'img-full-tk'">
      <img
        v-if="recordInfo.cover && recordInfo.cover.length"
        :src="
          'https://img.library.sh.cn/hisdata/cp/img/' +
          recordInfo.cover[picIndex]
        "
        alt=""
      />
      <a href="javascript:" class="prev" @click="prev"></a>
      <a href="javascript:" class="next" @click="next"></a>
      <a href="javascript:" class="close" @click="quit"></a>
      <!-- <p class="name">封面图</p> -->
    </div>
  </div>
</template>

<script>
import Nav from "@/components/nav";
import Player from "@/components/player";
import ShareDialog from "@/components/shareDialog";
import ShareIcon from "@/components/shareIcon";
import SingerTemplate from "@/components/singer";
import { baseMusicPic, baseRecordPic } from "@/util/basePic";
import { phonorecordInfo, collFav, ncollFav, musicList } from "@/api";
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(
  navigator.userAgent
);
export default {
  components: {
    Nav,
    Player,
    ShareIcon,
    ShareDialog,
    SingerTemplate,
  },
  data() {
    return {
      playIndex: -1,
      curIndex: -1,
      loginHref: null,
      isplay: false,
      noplay: false,
      picTabScroll: 0,
      player: [],
      queryUri: decodeURIComponent(this.$route.params.id),
      picIndex: 0,
      imgView: false,
      isMobile,
      detail: {
        isFav: false,
      },
      baseRecordPic,
      baseMusicPic,
      playerList: [],
      isFav: false,
      showMore: false,
      visible: false,
      recordInfo: {},
      song: [],
      audioList: [],
    };
  },
  computed: {
    hasShelfMark() {
      const { recordInfo } = this;
      if (recordInfo.item && Array.isArray(recordInfo.item) && recordInfo.item.length) {
        return true;
      }
      return !!recordInfo.item.shelfMark
    }
  },
  watch: {
    //解决此画面打开时，再从浏览器通过其他参数打开该画面 能正常打开
    $route(to, from) {
      var id = this.$route.params.id;
      //console.log("route change", id);

      this.queryUri = decodeURIComponent(this.$route.params.id);
      this.query();
    },
  },
  beforeRouteLeave(to, form, next) {
    this.$refs.player.savePlayer();
    next();
  },
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (isMobile) {
        if (value.length > 20) {
          return value.slice(0, 20) + "...";
        }
      } else {
        if (value.length > 30) {
          return value.slice(0, 30) + "...";
        }
      }
      return value;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.autoTap();
      this.query();
    });
    this.loginHref = this.GLOBAL.BASE_LOGIN_URL + window.location.href;
  },
  methods: {
    async query(flag = true) {
      const resPhonorecord = await phonorecordInfo({ uri: this.queryUri });

      const resMusicList = await musicList({
        field: "RECORD",
        value: this.queryUri,
        pageSize: 100,
      });
      //唱片详情
      this.recordInfo =
        resPhonorecord.data && resPhonorecord.data.datas
          ? resPhonorecord.data.datas
          : {};
      //题名处理 begin
      let tming = [];
      tming.push(this.recordInfo.variantTitle);
      let titles = [];
      if (this.recordInfo && this.recordInfo.variantTitle) {
        titles = Array.isArray(this.recordInfo.variantTitle)
          ? this.recordInfo.variantTitle
          : tming;
        console.log(titles[0].label);
        titles.forEach((item, index) => {
          if (item.variantType == "总题名") {
            this.recordInfo["mytitle"] = item.label
              .replace("~", "")
              .replace("=", "")
              .replace(":", "")
              .replace("/", "")
              .replace(/[||]/g, ":")
              .replace("::", ":");
          }
        });
      }
      if (this.recordInfo["mytitle"] == null) {
        this.recordInfo["mytitle"] = this.recordInfo.dcTitle["@value"]
          .replace("~", "")
          .replace("=", "")
          .replace(":", "")
          .replace("/", "")
          .replace(/[||]/g, "");
      }
      if (this.recordInfo["mytitle"].slice(-1) == ":") {
        this.recordInfo["mytitle"] = this.recordInfo["mytitle"].slice(
          0,
          this.recordInfo["mytitle"].length - 1
        );
      }
      //题名处理 end
      //曲目列表
      this.audioList = resMusicList.data.datas;
    },
    //点击名字需要跳转曲目详情
    titleClick(item) {
      this.$router.push("/song-detail/" + encodeURIComponent(item["@id"]));
    },
    picTabScrollHandle(flag) {
      if (flag) {
        this.picTabScroll++;
      } else {
        this.picTabScroll--;
      }
      this.picIndex = this.picTabScroll + 1;
    },
    async addAll() {
      this.$refs.player.playSong(this.$refs.Nav, this.recordInfo);
    },
    autoTap() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(() => {
        if (
          this.recordInfo.cover != null &&
          this.picIndex < this.recordInfo.cover.length - 1
        ) {
          this.picIndex++;
          this.picTabScroll =
            this.picIndex > 1 ? this.picIndex - 1 : this.picTabScroll;
        } else {
          this.picIndex = 0;
          this.picTabScroll = 0;
        }
      }, 5000);
    },
    checkPic() {
      clearInterval(this.timer);
      this.imgView = true;
    },
    prev() {
      if (this.picIndex === 0) {
        this.picIndex = this.recordInfo.cover.length - 1;
      } else {
        this.picIndex--;
      }
    },
    next() {
      if (this.picIndex === this.recordInfo.cover.length - 1) {
        this.picIndex = 0;
      } else {
        this.picIndex++;
      }
    },
    quit() {
      this.imgView = false;
      this.autoTap();
    },
    curPlay() {
      this.playIndex = this.curIndex;
    },
    playSong(item, index) {
      if (this.playIndex == index) {
        this.playIndex = -1;
        this.$refs.player.play();
        return;
      }
      this.curIndex = index;
      this.$refs.player.playSingleSong(this.$refs.Nav, item);
    },
    async handleSingleFav() {
      if (
        !localStorage.getItem("token") ||
        localStorage.getItem("token") == ""
      ) {
        this.$refs.Nav.showTk(2);
        return;
      }
      const res = this.recordInfo.isFavorite
        ? await ncollFav({ uri: this.recordInfo["@id"] })
        : await collFav({ uri: this.recordInfo["@id"] });
      this.recordInfo.isFavorite = !this.recordInfo.isFavorite;
      this.$refs.Nav.cpnclick(this.recordInfo.isFavorite);
    },
    saveFav(data) {
      this.audioList.forEach((i, k) => {
        if (i["@id"] == data["singer"]) {
          this.audioList[k]["isFavorite"] = !this.audioList[k]["isFavorite"];
        }
      });
    },
    isplayhandleCancel() {
      this.isplay = false;
    },
    async handleFav(index) {
      if (
        !localStorage.getItem("token") ||
        localStorage.getItem("token") == ""
      ) {
        this.$refs.Nav.showTk(2);
        return;
      }
      const res = this.audioList[index].isFavorite
        ? await ncollFav({ uri: this.audioList[index]["@id"] })
        : await collFav({ uri: this.audioList[index]["@id"] });

      this.audioList.splice(index, 1, {
        ...this.audioList[index],
        isFavorite: !this.audioList[index].isFavorite,
      });
      this.$refs.player.saveFav(this.audioList[index]);
      this.$refs.Nav.cpnclick(this.audioList[index].isFavorite);
    },
    handleShare() {
      // this.$refs.share.visible=!this.$refs.share.visible
      this.$refs.share.show();
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
